import React from 'react';
import Header from './components/Header.js';
import Hero from './components/Hero.js';
import Servizi from './components/Servizi.js';
import Materiali from './components/Materiali.js';
import Applicazioni from './components/Applicazioni.js';
import Certificazioni from './components/Certificazioni.js';
import Contatti from './components/Contatti.js';
import Footer from './components/Footer.js';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        <Hero />
        <Servizi />
        <Materiali />
        <Applicazioni />
        <Certificazioni />
        <Contatti />
      </main>
      <Footer />
    </div>
  );
}

export default App;